import React, { Component } from 'react'
import * as s from './SecondQuestion.module.css'
import Button from '../../ui/Button'
import { StaticImage } from 'gatsby-plugin-image';

const SecondQuestion = (props) => {
    const [checkedOne, setCheckedOne] = React.useState(false);
    const [checkedTwo, setCheckedTwo] = React.useState(false);
    const [checkedThree, setCheckedThree] = React.useState(false);
    const [checkedFour, setCheckedFour] = React.useState(false);
    
  
    const handleChangeOne = () => {
      setCheckedOne(!checkedOne);
    };
    const handleChangeTwo = () => {
        setCheckedTwo(!checkedTwo);
    };
    const handleChangeTree = () => {
        setCheckedThree(!checkedThree);
    };
    const handleChangeFour = () => {
        setCheckedFour(!checkedFour);
    };
  

    return (
        <div className={s.wrapper}>
            <h1 className={s.headline} >Lorem ipsum, dolor sit amet consectetur adipisicing elit</h1>
            <div className={s.questionBlok}>
            <label className={s.question} >
                <input type="checkbox"  value={checkedOne}   onClick={handleChangeOne} />
                <span className={s.inputText} >Lorem ipsum, dolor sit amet consectetur adipisicing elit</span>
                {
                    checkedOne === false ? 
                    <StaticImage src="../../../images/checkbox-black.svg"  className={s.checkboxIcon}/> :
                    <>
                    <StaticImage src="../../../images/checkbox-blue.svg"  className={s.checkboxIcon}/>
                    <StaticImage src="../../../images/checkbox-check-blue.svg"  className={s.checkboxCheckIcon}/>
                    </>
                }
            </label>
            <label className={s.question} >
                <input type="checkbox"  value={checkedOne}   onClick={handleChangeTwo} />
                <span className={s.inputText} >Lorem ipsum, dolor sit amet consectetur adipisicing elit</span>
                {
                    checkedTwo === false ? 
                    <StaticImage src="../../../images/checkbox-black.svg"  className={s.checkboxIcon}/> :
                    <>
                    <StaticImage src="../../../images/checkbox-blue.svg"  className={s.checkboxIcon}/>
                    <StaticImage src="../../../images/checkbox-check-blue.svg"  className={s.checkboxCheckIcon}/>
                    </>
                }
            </label>
            <label className={s.question} >
                <input type="checkbox"  value={checkedOne}   onClick={handleChangeTree} />
                <span className={s.inputText} >Lorem ipsum, dolor sit amet consectetur adipisicing elit</span>
                {
                    checkedThree === false ? 
                    <StaticImage src="../../../images/checkbox-black.svg"  className={s.checkboxIcon}/> :
                    <>
                    <StaticImage src="../../../images/checkbox-blue.svg"  className={s.checkboxIcon}/>
                    <StaticImage src="../../../images/checkbox-check-blue.svg"  className={s.checkboxCheckIcon}/>
                    </>
                }
            </label>
            <label className={s.question} >
                <input type="checkbox"  value={checkedOne}   onClick={handleChangeFour} />
                <span className={s.inputText} >Lorem ipsum, dolor sit amet consectetur adipisicing elit</span>
                {
                    checkedFour === false ? 
                    <StaticImage src="../../../images/checkbox-black.svg"  className={s.checkboxIcon}/> :
                    <>
                    <StaticImage src="../../../images/checkbox-blue.svg"  className={s.checkboxIcon}/>
                    <StaticImage src="../../../images/checkbox-check-blue.svg"  className={s.checkboxCheckIcon}/>
                    </>
                }
            </label>
           
        </div>
        <Button buttonText="weiter"/>
    </div>
    )

}

export default SecondQuestion;

